<div class="strategy-wrapper">
  <ng-container *ngIf="strategyInfoLoaded$ | async; else loadingState">
    <div class="intro-title">
      <h1 class="ui-headline">{{ 'new_strategy.portfolio_screen.h2_3a' | translate }}</h1>
      <p [innerHTML]="'new_strategy.portfolio_screen.' + (currentAccount.step_status === 5 ? 'p5_3a' : 'p') | translate"></p>
    </div>

    <div class="summary-head">
      <app-strategy-3a-portfolio-summary [currentAccount]="currentAccount" [customer]="customer"></app-strategy-3a-portfolio-summary>
    </div>

    <div>
      <app-setup-portfolio-stocks-bonds
        [investmentData]="investmentData"
        [step]="currentAccount.step_status"
        [kind]="currentAccount.kind"
        [bonds]="bondList"
        [isEve2]="true"
      ></app-setup-portfolio-stocks-bonds>
    </div>

    <app-strategy-stock-allocation
      *ngIf="currentAccount?.step_status < 5 || investmentData?.current_amount > 0"
      [customer]="customer"
    ></app-strategy-stock-allocation>

    <ng-container *ngIf="currentAccount?.step_status < 5; else customerGraph">
      <app-strategy-3a-portfolio-estimated-development [customer]="customer"></app-strategy-3a-portfolio-estimated-development>
    </ng-container>

    <ng-template #customerGraph>
      <div class="portfolio-box">
        <app-savings-analysis-3a
          [customer]="customer"
          [currentAccount]="currentAccount"
          [customerInvestment]="investmentData"
          [contributionLevel]="currentAccount?.max_contribution_level"
          [hideSavingsPlan]="true"
        >
        </app-savings-analysis-3a>
      </div>
    </ng-template>

    <ng-container *ngIf="currentAccount.step_status < 5">
      <app-strategy-3a-portfolio-fees [totalFee]="currentAccount.inyova_fee" [language]="customer.language"></app-strategy-3a-portfolio-fees>
      <app-strategy-portfolio-customer-support [totalFee]="currentAccount.inyova_fee"></app-strategy-portfolio-customer-support>
    </ng-container>
  </ng-container>
  <ng-template #loadingState>
    <app-loading-spinner class="loading-spinner"></app-loading-spinner>
  </ng-template>
</div>

<app-footer>
  <ng-container *ngIf="currentAccount.step_status <= 2">
    <button *ngIf="(flipperBookConsultation$ | async)?.attributes.value" (click)="bookModal(true)" class="ui-button secondary">
      {{ 'cta_book_consultation' | translate }}
    </button>
    <button routerLink="/3a/account-opening" class="ui-button attention">
      {{ 'cta_open_account' | translate }}
    </button>
  </ng-container>
  <ng-container class="alert" *ngIf="currentAccount.step_status === 3 && currentAccount.onboarding_step < 7">
    <button routerLink="/3a/account-opening" class="ui-button">
      {{ 'strategy.cta.signContract' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="currentAccount.step_status === 4 || (currentAccount.step_status === 3 && currentAccount.onboarding_step >= 7)">
    <button routerLink="/next/fund" class="ui-button attention">
      {{ 'cta_transfer_money' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="currentAccount.step_status === 5">
    @if (isEditMode && strategyWasChanged) {
      <button (click)="discardStrategy()" class="ui-button secondary" [disabled]="isSavingStrategyChangesEve2$ | async">
        {{ 'new_strategy.portfolio_screen.edit_mode.discard' | translate }}
      </button>
      <button
        (click)="saveStrategy()"
        class="ui-button"
        [class.loading]="isSavingStrategyChangesEve2$ | async"
        [disabled]="isSavingStrategyChangesEve2$ | async"
      >
        {{ 'new_strategy.portfolio_screen.edit_mode.save' | translate }}
      </button>
    } @else if (isEditMode && !strategyWasChanged) {
      <button (click)="discardStrategy()" class="ui-button">
        {{ 'new_strategy.portfolio_screen.back_cta' | translate }}
      </button>
    } @else {
      <button (click)="changeStrategy()" class="ui-button secondary" [disabled]="changeStrategyDisabled">
        {{ 'cta_change' | translate }}
      </button>
      <button [routerLink]="'/adjust-investment'" class="ui-button">
        {{ 'reinvest.savings_cta' | translate }}
      </button>
    }
  </ng-container>
</app-footer>

<button
  class="ui-button-text back-to-top"
  [ngClass]="{ active: showScroll === true, 'align-lower': currentAccount.step_status === 3 || currentAccount.step_status === 4 }"
  (click)="scrollTop()"
>
  <span>{{ 'strategy.portfolio.backToTop' | translate }}</span>
  <span class="icon-i-chevron-up"></span>
</button>

<app-dialog-book-consultation
  *ngIf="bookConsultation"
  (bookModal)="bookModal($event)"
  [appLocation]="customer.app_location"
  [accountId]="currentAccount.id"
></app-dialog-book-consultation>
